__turbopack_context__.v({
  "arrow": "popover-module-scss-module__wBXZuG__arrow",
  "arrowWrapper": "popover-module-scss-module__wBXZuG__arrowWrapper",
  "bottom": "popover-module-scss-module__wBXZuG__bottom",
  "bottom-end": "popover-module-scss-module__wBXZuG__bottom-end",
  "bottom-start": "popover-module-scss-module__wBXZuG__bottom-start",
  "content": "popover-module-scss-module__wBXZuG__content",
  "darkTheme": "popover-module-scss-module__wBXZuG__darkTheme",
  "isVisible": "popover-module-scss-module__wBXZuG__isVisible",
  "left": "popover-module-scss-module__wBXZuG__left",
  "left-end": "popover-module-scss-module__wBXZuG__left-end",
  "left-start": "popover-module-scss-module__wBXZuG__left-start",
  "popover": "popover-module-scss-module__wBXZuG__popover",
  "right": "popover-module-scss-module__wBXZuG__right",
  "right-end": "popover-module-scss-module__wBXZuG__right-end",
  "right-start": "popover-module-scss-module__wBXZuG__right-start",
  "top": "popover-module-scss-module__wBXZuG__top",
  "top-end": "popover-module-scss-module__wBXZuG__top-end",
  "top-start": "popover-module-scss-module__wBXZuG__top-start",
});
